import type { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'
import type { LogGivingActionParams, LogGivingActionResponse } from './logGivingAction.types'

export const logGivingAction: MutationFn<LogGivingActionParams, LogGivingActionResponse> = async (
  client,
  { actionId, targetType, targetId, completedAt }
) =>
  (
    await client.post<LogGivingActionResponse>(
      `v1/giving-actions/${actionId}/log`,
      {
        target: targetType,
        targetId,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...(completedAt ? { completedAt } : {})
      },
      {
        withCredentials: true
      }
    )
  ).data
